<div class="offer-detail-main-block">
  <div class="offer-bg-image-block">
    <img class="shadow-sm rounded-lg" [src]="cardLinkOfferDtail.ImageUrl | contentImage: '6'" />
  </div>

  <div class="offer-detail-block">
    <div class="offer-detail-img-name-block">
      <div class="offer-detail-image-block">
        <div class="offer-detail-image">
          <img [src]="cardLinkOfferDtail.CompanyImageUrl | contentImage: '7'" />
        </div>
      </div>
      <p class="offer-name-title">{{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'Name' }}</p>
    </div>

    <div class="offer-detail-text-block">
      <ng-container *ngIf="cardLinkOfferDtail.Favorite">
        <p class="feature-Offer-text">
          <span class="icon material-icons">star</span>{{ 'fgbcl.card.linking.feature.offer.title' | translate }}
        </p>
      </ng-container>

      <p class="offer-detail-description">
        {{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'description' | shortText: 45 }}
      </p>

      <div *ngIf="cardLinkOfferDtail.OfferLocations != 0" class="btn-online-instore-block">
        <div *ngIf="cardLinkOfferDtail.OfferLocations == 1 || cardLinkOfferDtail.OfferLocations == 3" class="chip btn-online">
          {{ 'fgbcl.card.linking.succes.offer.online.button.title' | translate }}
        </div>
        <div *ngIf="cardLinkOfferDtail.OfferLocations == 2 || cardLinkOfferDtail.OfferLocations == 3" class="chip btn-instore">
          {{ 'fgbcl.card.linking.succes.offer.instore.button.title' | translate }}
        </div>
      </div>
      <div class="offer-details-tabs">
        <p [ngClass]="{ 'tab-disable': currentTab != 'description' }" (click)="currentTab = 'description'">
          {{ 'fgbcl.offer.detail.tab-text-desc' | translate }}
        </p>
        <ng-container *ngIf="cardLinkOfferDtail.TermsAndConditions">
          <p [ngClass]="{ 'tab-disable': currentTab != 'viewexemptios' }" (click)="currentTab = 'viewexemptios'">
            {{ 'fgbcl.offer.detail.tab-viewexem-text' | translate }}
          </p>
        </ng-container>
      </div>
    </div>
    <div class="offer-details-tabs-text">
      <hr class="horizontal-line" />
      <p *ngIf="currentTab == 'description'">
        {{ cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'description' }}
      </p>
      <p *ngIf="currentTab == 'viewexemptios'">
        <ng-container *ngIf="cardLinkOfferDtail.TermsAndConditionsType == 1">
          {{ cardLinkOfferDtail.TermsAndConditions }}
        </ng-container>
      </p>

      <button
        (click)="activateOffer(cardLinkOfferDtail.OfferId)"
        *ngIf="cardLinkOfferDtail.CustomerOfferStatus == 0 && cardLinkOfferDtail.OfferType == 6"
        class="btn btn-success"
      >
        {{ 'fgbcl.offer.detail.activate.offer.button.text' | translate }}
      </button>
      <button
        #shopNowBtn
        (click)="selectedOffer = cardLinkOfferDtail; modelContent = content"
        *ngIf="cardLinkOfferDtail.OfferType !== 4 && cardLinkOfferDtail.OfferType !== 6"
        class="btn shop-now"
      >
        {{ 'fgbcl.offer.detail.shop.now.button.text' | translate }}
      </button>
      <div
        class="d-flex flex-row align-items-center justify-content-center"
        *ngIf="cardLinkOfferDtail.CustomerOfferStatus == 1 && cardLinkOfferDtail.OfferType == 6"
      >
        <button class="offer-button added-offer mt-0"><span class="icon material-icons">done</span></button>
        <p class="text-success mb-0 ms-2 mt-0">
          {{ 'fgbcl.offer.detail.activated.offer.button.text' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <fgbcl-card-link-external-url-modal
    [companyImageUrl]="selectedOffer.CompanyImageUrl"
    [navigationUrl]="cardLinkActivateOffer.RedirectUrl"
    [clubImageUrl]="clubImageUrl"
    [offerDescription]="cardLinkOfferDtail.Content | currentLanguageContent: currentLcid:'description' | shortText: 20"
  ></fgbcl-card-link-external-url-modal>
</ng-template>

<ng-template #cardNotLinkModal let-modal>
  <div class="card-not-link-model container p-2 overflow-auto">
    <div class="card-not-link-model-header">
      <span class="icon material-icons">link</span>
      <p class="card-not-link-model-header-title">{{ 'fgbcl.card.linking.link.card.not.link.title' | translate }}</p>
    </div>
    <hr class="horizontal-line" />
    <div class="container">
      <p class="card-not-link-model-description text-center">{{ 'fgbcl.card.linking.card.not.link.description' | translate }}</p>
    </div>
    <div class="card-not-link-model-link-card-button d-flex align-items-center justify-content-center my-4">
      <button class="btn btn-success" (click)="linkCard()">
        {{ 'fgbcl.card.linking.model.link.card.button.title' | translate }}
      </button>
    </div>
  </div>
</ng-template>
